import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DeliverableProjectsDataGrid } from "src/components/views/erp/project/delivery/DeliverableProjectsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/project/delivery/deliverableProjects")({
	staticData: { title: i18n.t("deliverable_projects"), legacyViewKey: "deliverableProjectsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DeliverableProjectsDataGrid />;
}
